import { h } from 'preact'

import { EscalationModalProps } from '../../interfaces'
import { ModalActionButtons, ModalTitle } from '../../ModalComponents'

/* eslint-disable import/no-internal-modules */
import Modal from '../../../../../../components/reactModal'
import Icon from '@insided/deprecated-preact-components/assets'
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import Textarea from '@insided/deprecated-control/ui-components/Textarea'
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'
import ButtonControl from '@insided/deprecated-preact-components/button-control'
import { ItemsList } from '@insided/deprecated-preact-components/dropdown/interfaces'

interface Props extends EscalationModalProps {
  groups?: ItemsList
  selectedGroup?: string | null
  errorFields?: string []
  isGroupsLoading: boolean
}

const CreateFreshdeskModal = ({ isOpen, closeModal, onSubmit, title, username, onChangeCallback, content, onContentChange, groups, selectedGroup, onTextareaFocus, onClickCallback, isLoading, isGroupsLoading, errorFields }: Props) => {
  const errorMessage = 'Please fill in the required field'
  const DropdownText = () => {
    if (groups?.length === 0 || isGroupsLoading) return <div className='timezone-selector-placeholder'>Loading group names...</div>
    return selectedGroup
      ? <span className='selected'>
        <div className='truncated'>{selectedGroup}</div>
      </span>
      : <div className='group-selector-placeholder'>Select a group</div>
  }
  return (
    <Modal isOpen={isOpen} onClose={() => closeModal()}>
      <div className='integration__create_freshdesk_ticket_modal integration__escalate_modal'>
        <ModalTitle title='Create a Freshdesk ticket' imageName='freshdesk' />
        <div className='modal-description'>
          <div className='modal-user-email-field modal-data'>
            <label>User</label>
            <div>{username}</div>
          </div>
          <div className='modal-post-title-field modal-data'>
            <InputGroup
              title='Title'
              key='post-title'
              required
              qaClasses='qa-post-title'
              value={title}
              error={errorFields?.includes('title') ? errorMessage : ''}
              onChangeCallback={(e: ChangeEvent) => onChangeCallback(e.target.value)}
              onClick={() => onClickCallback()}
              showIconBeforeErrorMessage
            />
          </div>
          <div className='modal-group-field modal-data'>
            <label>Group</label>
            <div className='group-selector-wrapper'>
              <DropdownControl
                closeOnDropdownClick
                className='group-dropdown'
                triggerClass='group-selector-trigger'
                align='adjust'
                trigger={(isTriggerOpen: boolean) =>
                    // eslint-disable-next-line @gorazdo/preact/prefer-classname
                  <ButtonControl title={<DropdownText />} class={`group-selector qa-group-selector ${isTriggerOpen ? 'group-selector-is-open' : 'group-selector-is-closed'} ${errorFields?.includes('group') ? 'validation-error' : ''}`} icon='chevronDown' />}
                items={groups !== undefined ? groups : []}
                hasSearch
                newStyle
                searchPlaceholderText='Search for group'
                searchIconHeight={16}
                searchIconWidth={16}
              />
              {errorFields?.includes('group') && <div className='error-message-container'>
                <div><Icon customClass='icon-warning' icon='warning' /></div>
                <div className='error-message-text'>{errorMessage}</div>
              </div>}
            </div>
          </div>
          <label>Description</label>
          <div className='modal-post-content-field modal-data'>
            <Textarea
              adjustHeight
              verticalResize
                // eslint-disable-next-line @gorazdo/preact/prefer-classname
              class='modal-post-content'
              newStyle
              onContentChange={(value: string) => onContentChange(value)}
              value={content?.replace(/<[^>]*>?/gm, ' ') ?? ''}
              error={errorFields?.includes('description')}
              onTextareaFocus={() => onTextareaFocus()}
            />
            {errorFields?.includes('description') && <div className='error-message-container'>
              <div><Icon customClass='icon-warning' icon='warning' /></div>
              <div className='error-message-text'>{errorMessage}</div>
            </div>}
          </div>
        </div>
        <ModalActionButtons onSubmit={() => onSubmit()} isLoading={isLoading} closeModal={() => closeModal()} />
      </div>
    </Modal>
  )
}

export default CreateFreshdeskModal
